import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 py-8 min-h-screen flex flex-col max-w-3xl" }
const _hoisted_2 = { class: "flex justify-between items-center mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold" }, "게시글 예시 관리", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-center text-gray-500 my-8"
}
const _hoisted_5 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_6 = { class: "whitespace-pre-wrap text-sm" }

import { ref, onMounted, computed } from "vue";
import { usePostExampleStore } from "@/stores/postExampleStore";
import { useUserStore } from "@/stores/userStore";
import Button from "primevue/button";
import Panel from "primevue/panel";
import ExampleModal from "@/components/ExampleModal.vue";
import Menu from "primevue/menu";
import ConfirmPopup from "primevue/confirmpopup";
import { useConfirm } from "primevue/useconfirm";
import type { PostExample } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExamplesDashboardPage',
  setup(__props) {

const postExampleStore = usePostExampleStore();
const userStore = useUserStore();
const modalVisible = ref(false);
const selectedExample = ref<PostExample>({
  id: "",
  user_id: "",
  content: "",
  created_at: "",
  updated_at: "",
});
const isEditing = ref(false);
const confirm = useConfirm();

const examples = computed(() => postExampleStore.examples);

onMounted(async () => {
  if (userStore.user) {
    await postExampleStore.fetchExamples(userStore.user.id);
  }
});

const openAddModal = () => {
  selectedExample.value = {
    id: "",
    user_id: "",
    content: "",
    created_at: "",
    updated_at: "",
  };
  isEditing.value = false;
  modalVisible.value = true;
};

const editExample = (example: PostExample) => {
  selectedExample.value = { ...example };
  isEditing.value = true;
  modalVisible.value = true;
};

const saveExample = async (content: string) => {
  if (userStore.user) {
    if (isEditing.value) {
      await postExampleStore.updateExample(selectedExample.value.id, content);
    } else {
      await postExampleStore.addExample(userStore.user.id, content);
    }
    modalVisible.value = false;
  }
};

const deleteExample = async (id: string) => {
  await postExampleStore.deleteExample(id);
};

const menu = ref();
const menuItems = ref([
  {
    label: "수정",
    icon: "pi pi-pencil",
    command: () => editExample(selectedExample.value),
  },
  {
    label: "삭제",
    icon: "pi pi-trash",
    command: (event: { originalEvent: { target: EventTarget } }) => {
      confirm.require({
        target: event.originalEvent.target as HTMLElement,
        message: "이 예시를 삭제하시겠습니까?",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          deleteExample(selectedExample.value.id);
        },
        reject: () => {
          // 아무 작업도 하지 않음
        },
      });
    },
  },
]);

const toggleMenu = (event: Event, exampleId: string) => {
  selectedExample.value =
    examples.value.find((e) => e.id === exampleId) || selectedExample.value;
  menu.value.toggle(event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(Button), {
        label: "새 예시 추가",
        icon: "pi pi-plus",
        onClick: openAddModal,
        class: "p-button-primary"
      })
    ]),
    (examples.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 예시가 없습니다. 새로운 예시를 추가해보세요! "))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examples.value, (example, index) => {
            return (_openBlock(), _createBlock(_unref(Panel), {
              key: example.id,
              header: `예시 #${index + 1}`,
              toggleable: true,
              class: "mb-2"
            }, {
              icons: _withCtx(() => [
                _createVNode(_unref(Button), {
                  icon: "pi pi-cog",
                  text: "",
                  rounded: "",
                  "aria-label": "Settings",
                  onClick: _withModifiers(($event: any) => (toggleMenu($event, example.id)), ["stop"])
                }, null, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_6, _toDisplayString(example.content), 1)
              ]),
              _: 2
            }, 1032, ["header"]))
          }), 128))
        ])),
    _createVNode(_unref(Menu), {
      ref_key: "menu",
      ref: menu,
      model: menuItems.value,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(_unref(ConfirmPopup)),
    _createVNode(ExampleModal, {
      visible: modalVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((modalVisible).value = $event)),
      "initial-content": selectedExample.value.content,
      "is-editing": isEditing.value,
      onSave: saveExample
    }, null, 8, ["visible", "initial-content", "is-editing"])
  ]))
}
}

})